import React from 'react'

export interface FileInputProps {
  onFiles: (files: FileList | null) => void
}

function FileInput({ onFiles }: FileInputProps) {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (onFiles && event.target.files?.length) {
      onFiles(event.target.files)
      event.target.value = ''
    }
  }

  return <input type="file" onChange={handleChange} multiple />
}

export default FileInput
